export default {
    zh: {
        noContentAvailable: '暂无更多内容',
        contactUs: '联系我们',
        schduleAVisit: '安排参观',
        applyNow: '立即申请',
        homeBtn: '开始我的行程',
        homeBtn1: '点击播放视频',
        yearsText: [
            '欢迎来到',
            // 浦东
            '上海德威外籍人员子女学校（浦东）',
            // 浦西
            // '上海德威外籍人员子女学校（浦西）',
            // 苏州国际高中
            // '苏州工业园区德威联合书院',
            '',
            '请在下面选择您孩子的年龄组开始参观：',
            // '请在下面选择您想参观的区域：',
            '更改年龄组',
            // '更改区域',
            '您想看什么？',
            '确认选择',
            '我想选择推荐的参观路径',
            '更改我的行程表',
            '这是您的行程表',
            '开始行程',
        ],
        prev: '上一个地点',
        next: '下一个地点',
        myTour: '我的行程',
        contactPuDong: '现在联系上海德威外籍人员子女学校（浦东）',
        // contactPuDong: '现在联系上海德威外籍人员子女学校（浦西）',
        // contactPuDong: '现在联系苏州德威国际高中',
        selectText: [
            {
                text: '约谈我们的招生团队',
                btn: '提出询问'
            },
            {
                text: '立即申请',
                btn: '提交申请'
            },
            {
                text: '继续参观学校',
                btn: '选择年龄组'
            },
        ],
        seeMore: '查看更多',
        replay: '重播'
    },
    en: {
        noContentAvailable: 'No Content Available',
        contactUs: 'CONTACT US',
        schduleAVisit: 'SCHEDULE A VISIT',
        applyNow: 'APPLY NOW',
        homeBtn: 'Start My Tour Now',
        homeBtn1: 'Play Video To Get Started',
        yearsText: [
            'Welcome to',
            // 浦东
            'DULWICH COLLEGE ',
            '| SHANGHAI PUDONG |',
            // 浦西
            // 'DULWICH COLLEGE ',
            // '| SHANGHAI PUXI |',
            // 苏州国际高中
            // 'DULWICH INTERNATIONAL HIGH SCHOOL ',
            // '| SUZHOU |',

            'Please choose your child’s age group below to start a tour:',
            // 'Please choose the area you are interested in to start a tour:',
            'Change Age Group',
            // 'Change Area',
            'What would you like to see?',
            'Confirm selection',
            'I would like to take the recommended tour',
            'Change My Itinerary',
            "Here's your itinerary",
            'Start my tour',
        ],
        prev: 'Previous location',
        next: 'Next location',
        myTour: 'My Tour Itinerary',
        contactPuDong: 'Connect with Dulwich College Shanghai Pudong Now',
        // contactPuDong: 'Connect with Dulwich College Shanghai Puxi Now',
        // contactPuDong: 'Connect with Dulwich International High School Suzhou Now',
        selectText: [
            {
                text: 'Talk to Our Admissions Team',
                btn: 'Submit an Enquiry'
            },
            {
                text: 'Apply Now',
                btn: 'Submit an Application'
            },
            {
                text: 'Continue Touring the College',
                btn: 'Select Age Group'
            },
        ],
        seeMore: 'See more',
        replay: 'Replay'
    }
}